import { render, staticRenderFns } from "./AccountSilverModal.vue?vue&type=template&id=2821a4d2&scoped=true&"
import script from "./AccountSilverModal.vue?vue&type=script&lang=js&"
export * from "./AccountSilverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2821a4d2",
  null
  
)

export default component.exports